import * as React from "react";
const SvgPerson = () => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 2.85a2.47 2.47 0 0 0-2.468 2.468v.614a2.469 2.469 0 0 0 4.936 0v-.614A2.47 2.47 0 0 0 9 2.85M5.332 5.318a3.669 3.669 0 0 1 7.336 0v.614a3.669 3.669 0 0 1-7.336 0zm-.826 6.203c1.188-.324 2.832-.667 4.494-.667s3.306.343 4.494.667a3.05 3.05 0 0 1 2.242 2.945v1.884H2.264v-1.884c0-1.372.912-2.582 2.242-2.945M9 12.055c-1.512 0-3.041.314-4.178.624a1.85 1.85 0 0 0-1.358 1.787v.684h11.072v-.684c0-.837-.556-1.569-1.358-1.787-1.136-.31-2.666-.624-4.178-.624",
    clipRule: "evenodd"
  }
));
export default SvgPerson;
